export const quotesDelayedRoutes = { delayed: { proxy: 'quotes/delayed', upstream: 'v2/quoteDelayed' } } as const;
